"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.inAttackRange = void 0;
const board_1 = require("@creature-chess/board");
const inAttackRange = (attacker, target, attackRange) => {
    const { x: deltaX, y: deltaY } = (0, board_1.getDelta)(attacker, target);
    // Pieces cannot attack diagonally
    const result = Math.min(deltaX, deltaY) === 0 && Math.max(deltaX, deltaY) <= attackRange;
    return result;
};
exports.inAttackRange = inAttackRange;
